module.exports = __webpack_public_path__ + "static/media/content.6f7c3564.png";


//////////////////
// WEBPACK FOOTER
// ./src/invitation/invitationOpen/image/content.png
// module id = 995
// module chunks = 0